import React from 'react';
import TeacherTableRow from './TeacherTableRow';

const TeacherTable = ({
  filteredTeachers,
  selectedIds,
  handleSelectChange,
  handleSelectAll,
  openFormForEdit,
  handleDelete,
  handleToggleStudentStatus,
  openFinancialModal,
  fetchTeacherLessons,
  handleLoginAsTeacher,
  teacherFinancials,
  teacherFinancialDetails,
  lessonGroups,
  statusToText,
  statusToColor
}) => {
  const allFilteredSelected = filteredTeachers.length > 0 && selectedIds.length === filteredTeachers.length;

  const thClass = "px-3 py-2 text-left text-xs font-medium text-gray-500";

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200">
            <th className="sticky left-0 z-10 bg-gray-50 px-3 py-2 w-8">
              <input
                type="checkbox"
                className="h-4 w-4 accent-gray-900"
                checked={allFilteredSelected}
                onChange={handleSelectAll}
                disabled={filteredTeachers.length === 0}
              />
            </th>
            <th className={thClass}>ID</th>
            <th className={thClass}>Ad Soyad</th>
            <th className={thClass}>Telefon</th>
            <th className={thClass}>E-Posta</th>
            <th className={thClass}>Parola</th>
            <th className={thClass}>Dersler</th>
            <th className={`${thClass} min-w-[200px]`}>Öğrenciler</th>
            <th className={thClass}>Ücret</th>
            <th className={thClass}>Durum</th>
            <th className={thClass}>Tarih</th>
            <th className={`${thClass} text-right`}>İşlem</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {filteredTeachers.map(teacher => {
            const isSelected = selectedIds.includes(teacher.id);
            const netUcret = teacherFinancials[teacher.id] || 0;
            const financialDetails = teacherFinancialDetails[teacher.id] || null;

            const dersAdlari = Array.isArray(teacher.ders)
              ? teacher.ders.map(d => {
                  const cleanedD = String(d).replace(/['"]/g, '');
                  const foundById = lessonGroups.find(g => String(g.id) === cleanedD);
                  if (foundById) return foundById.ders_adi;
                  const foundByName = lessonGroups.find(g => g.ders_adi === cleanedD);
                  return foundByName ? foundByName.ders_adi : cleanedD;
                })
              : [];

            return (
              <TeacherTableRow
                key={teacher.id}
                teacher={{ ...teacher, financialDetails }}
                isSelected={isSelected}
                onSelectChange={handleSelectChange}
                onEdit={openFormForEdit}
                onDelete={handleDelete}
                onToggleStudentStatus={handleToggleStudentStatus}
                onViewFinancial={openFinancialModal}
                onViewLessons={fetchTeacherLessons}
                onLoginAsTeacher={handleLoginAsTeacher}
                netUcret={netUcret}
                dersAdlari={dersAdlari}
                statusToText={statusToText}
                statusToColor={statusToColor}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TeacherTable;
